module.exports = __webpack_public_path__ + "img/live-end-cover.cf8b3519.jpg";